// extracted by mini-css-extract-plugin
module.exports = {"styles":"ZIhac8yPfDHUju7E8rvZx","menuStyles":"_1JZ-qCt_hKOFctqh-dyETx"};